<template>
    <Modal v-if="show" @close="closeModal">
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <div>
            The Service shall not be used for Restricted or
Prohibited Commodities (as defined by the JCA or
designated as such under the Customs Act),
including not limited to: Aerosols, Alcohol, Arms and
Ammunition, Animals and Animal Carcasses (as
prohibited under the Animals Diseases and
Importation Act), Appliances, Bullet Proof Vests,
Cash, Camouflage Clothing, Chemicals, Coconut
Derivatives, Contraband, Credit Card Scanning
Equipment, Drugs (as prohibited under the
Dangerous Drugs Act), Dynamite and Other
Explosives, Electronics, Crossbows and Longbows,
Fire Crackers, Firearm Accessories, Flowers, Fruits,
Garlic, Ground Provisions, Gun Holsters, Hazardous
Materials, Handguns, Herbal Teas, High Value
Jewellery, Human Remains, Knives and Swords,
Lasers, Light Pointers, Manuscripts, Meats, Metal
Detectors, Milk Based Products, Monetary
Instruments, Onions, Pepper Sprays, Percussion
Caps, Perishable Items, Pesticides,
Pharmaceuticals, Plants including Bulbs, Seeds and
Cuttings (as prohibited under the Plants Protection
from Disease Act), Precious Metals, Radar
Detectors, Radios, Red Beans, Riot Gear, Spear
Guns, Sugar, Tasers, Toy Guns, Vegetables, Wet
Cargo.

<br>
<br>

*Hazardous Materials include but are not limited to explosives; gases (compressed, deeply refrigerated, liquefied or dissolved under pressure);
flammable and combustible liquids; flammable solids; substances liable to spontaneous combustion; substances that on contact with water emit
flammable gases; oxidizing substances; organic peroxides, poisonous (toxic) and infectious substances; radioactive nuclear substances;
corrosives; miscellaneous products, substances or organisms which may reasonably be considered to be dangerous to life, health, property or the
environment when handled, transported by air; goods that by their nature or quantity either singly or collectively are liable to endanger life or
imperil property.

        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-primary" @click="closeModal">Close</button>
      </template>
    </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";

export default {
    components: {
        Modal,
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        }
    },
}
</script>

<style lang="scss" scoped>

</style>